import { useContext } from "react";
import { PageMetadataContext } from ".";
export const usePageMetadata = () => {
    const context = useContext(PageMetadataContext);
    if (context === undefined) {
        throw new Error(`usePageMetadata must be used within a PageMetadataProvider`);
    }
    return context;
};
//# sourceMappingURL=usePageMetadata.js.map